<expandable class="h4"
            [expandableId]="zippyId()"
            expandableIcon="chevron">
    <div expandableTitle
         [zippyName]="zippyId()"
         zippyClass="col-12">
        {{ label }}
        <div class="pos-absolute right-0 top-50 p1 col-12"
             [innerHTML]="getSelectedOptionsForFilter"></div>
    </div>

    <!-- options list -->
    <div expandableBody>
        <div class="flex flex-middle form-small">
            <div class="w-5">
                <label class="w-12 label m-b-1">{{'Low' | translate}}</label>
                <input class="input"
                       type="number"
                       step="1"
                       [min]="min || 0"
                       [max]="maxModel || 10000"
                       [(ngModel)]="minModel"
                       (ngModelChange)="onMinChange($event)">
            </div>
            <div class="w-2 m-t-2 fs-3 center">{{'to' | translate}}

            </div>
            <div class="w-5">
                <label class="w-12 label m-b-1">{{'High' | translate}}</label>
                <input class="input"
                       type="number"
                       step="1"
                       [min]="minModel || 0"
                       [max]="max || 10000"
                       [(ngModel)]="maxModel"
                       (ngModelChange)="onMaxChange($event)">
            </div>
        </div>
    </div>
</expandable>